import { c as _c } from "react/compiler-runtime";
import { Box, HStack, Icon, IconButton, Input, StackProps } from '@chakra-ui/react';
import React, { FormEvent, useState } from 'react';
import { LuArrowUp, LuSparkles } from 'react-icons/lu';
export type HomeAskBarProps = {
  placeholder?: string;
  defaultValue?: string;
  onAsk?: (query: string) => void;
  containerProps?: StackProps;
};

/**
 * Hero ask input from the homepage mockup — sparkle affordance, free-text field, circular send.
 */
export const HomeAskBar: React.FC<HomeAskBarProps> = t0 => {
  const $ = _c(24);
  const {
    placeholder: t1,
    defaultValue: t2,
    onAsk,
    containerProps
  } = t0;
  const placeholder = t1 === undefined ? "How can we grow your startup today?" : t1;
  const defaultValue = t2 === undefined ? "" : t2;
  const [value, setValue] = useState(defaultValue);
  let t3;
  if ($[0] !== onAsk || $[1] !== value) {
    t3 = event => {
      event.preventDefault();
      const query = value.trim();
      if (!query) {
        return;
      }
      onAsk?.(query);
    };
    $[0] = onAsk;
    $[1] = value;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleSubmit = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      borderColor: "orange.400"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Icon aria-hidden={true} as={LuSparkles} boxSize={5} color="orange.400" flexShrink={0} />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      boxShadow: "none",
      borderColor: "transparent"
    };
    t7 = {
      color: "fg.subtle"
    };
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = ["md", "lg"];
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = event_0 => setValue(event_0.target.value);
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== placeholder || $[10] !== value) {
    t10 = <Input _focusVisible={t6} _placeholder={t7} aria-label={placeholder} border="none" boxShadow="none" color="fg" flex={1} fontSize={t8} minWidth={0} placeholder={placeholder} value={value} variant="flushed" onChange={t9} />;
    $[9] = placeholder;
    $[10] = value;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== value) {
    t11 = value.trim();
    $[12] = value;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const t12 = !t11;
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <LuArrowUp />;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t12) {
    t14 = <IconButton aria-label="Ask" borderRadius="full" boxSize="48px" disabled={t12} flexShrink={0} minWidth="48px" type="submit" variant="cta">{t13}</IconButton>;
    $[15] = t12;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== handleSubmit || $[18] !== t10 || $[19] !== t14) {
    t15 = <HStack _focusWithin={t4} align="center" as="form" bg="bg.subtle" borderColor="border.emphasized" borderRadius="2xl" borderWidth="1px" gap={3} paddingLeft={5} paddingRight={4} paddingY={4} transition="border-color 0.15s ease" onSubmit={handleSubmit} width="full" minHeight="70px">{t5}{t10}{t14}</HStack>;
    $[17] = handleSubmit;
    $[18] = t10;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== containerProps || $[22] !== t15) {
    t16 = <Box as="section" display="flex" justifyContent="center" paddingBottom={2} width="full" {...containerProps}>{t15}</Box>;
    $[21] = containerProps;
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  return t16;
};